import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import './grid-header.css';
import VnButton from '../VnButton';
import { searchOutline } from 'ionicons/icons';
const VnGridHeader = ({ showSearch, onSearch }) => {
    const [searchText, setSearchText] = useState('');
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };
    const handleSearch = () => {
        if (onSearch) {
            onSearch(searchText);
        }
    };
    return (_jsx("div", { children: !!showSearch && (_jsxs("div", { className: 'vn-SearchInput-Container', children: [_jsxs("div", { className: 'input-group vn-Search-Button', children: [_jsx("input", { type: 'text', className: 'form-control vn-SearchInput', placeholder: 'Zoekopdracht...', "aria-label": "Recipient's username with two button addons", "aria-describedby": 'button-addon4', value: searchText, onChange: handleSearchChange }), _jsx("div", { className: 'input-group-append', id: 'button-addon4', children: _jsx(VnButton, { customClassName: 'vn-search-button', mode: 'primary', size: 'sm', icon: searchOutline, onClick: handleSearch }) })] }), _jsx("div", {})] })) }));
};
export default VnGridHeader;
